const RX_ADMINISTRATION_ROLE_IDS = [1, 14, 35, 36, 41, 42];
const ADMINISTRATION_ROLE_IDS = [43, 44];
// CEO (1), VP - Clinical Lead (36), VP - Operations & Internal Affairs (35)
const REEL_MEMBER_RX_ADMIN_ROLE_IDS = [1, 35, 36];

const getCompanyRoleId = (companyRole) => {
  if (!companyRole) {
    return null;
  }

  // Supports different payload shapes sent by backend/frontend mappings.
  const rawRoleId =
    companyRole.id ??
    companyRole.Id ??
    companyRole.roleId ??
    companyRole.RoleId ??
    companyRole.companyRoleId;
  const parsedRoleId = Number(rawRoleId);

  if (Number.isNaN(parsedRoleId)) {
    return null;
  }

  return parsedRoleId;
};

export const isUserReelMember = (currentLoggedInUserDetail) =>
  Boolean(currentLoggedInUserDetail?.isReelMember);

export const hasAccessToRxAdministration = (companyRole) => {
  const roleId = getCompanyRoleId(companyRole);
  return roleId !== null && RX_ADMINISTRATION_ROLE_IDS.includes(roleId);
};

// Returns true if a REEL member is permitted to access Rx Administration.
// Only CEO and VP roles can see Rx Administration as REEL members.
export const canReelMemberAccessRxAdministration = (companyRole) => {
  const roleId = getCompanyRoleId(companyRole);
  return roleId !== null && REEL_MEMBER_RX_ADMIN_ROLE_IDS.includes(roleId);
};

export const hasAccessToAdministration = (companyRole) => {
  const roleId = getCompanyRoleId(companyRole);
  return roleId !== null && ADMINISTRATION_ROLE_IDS.includes(roleId);
};

export const hasAccessToEnvAdministration = (companyRole) => [
  Boolean(companyRole?.hasAccessToDevAdmin),
  Boolean(companyRole?.hasAccessToStagingAdmin),
  Boolean(companyRole?.hasAccessToProdAdmin),
];

export const hasAccessToEnvClinical = (companyRole) => [
  Boolean(companyRole?.hasAccessToDevClinical),
  Boolean(companyRole?.hasAccessToStagingClinical),
  Boolean(companyRole?.hasAccessToProdClinical),
];

